export default "__VITE_ASSET__CDxVTVE7__"